import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  resourcesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  resourcesItem: {
    ...theme.mixins.appContainer,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
  resourceIcon: {
    width: 24,
    height: 24,
    display: 'block',
    color: theme.palette.text.primary,
    flexShrink: 0,
  },
}));
